import React, {useEffect, useState} from "react";
import {
    basePath,
    nonStandardColors,
    oxideColors,
    standardColors,
} from "../../../../lib/constant";
import {useAppContext} from "../../../../context/AppContext";
import {useFormContext, useWatch,Controller} from "react-hook-form";

const DoorColourRadiogroup = ({type, register, setValue, control, view,oxide,input_name,getValues}) => {
    const [colourArray, setColourArray] = useState(standardColors);

    const {
        setSelectedInternalColourType,
        setSelectedInternalSlabColourType,
        setSelectedExternallColourType,
        setSelectedExternalFrameColourType,
        setSelectedExternalSlabColourType,
        state:{view:currentView} ,
        setView
    } = useAppContext();

    const {watch} = useFormContext();

    const selectedDoor = watch("external_door_style");

    // Watch the correct field based on input_name
    const watchFieldName = input_name || `${view}_door_colour`;

    const selectedOption = useWatch({
        control,
        name: watchFieldName,
    });
    useEffect(() => {
        // Only set the value if we're not already watching the correct field
        if (!input_name) {
            setValue(`${view}_door_colour`, selectedOption);
        }
        // Only set the value if we're not already watching the correct field
        if (!input_name) {
            setValue(`${view}_door_colour`, selectedOption);
        }

        if (view === "internal") {
            if (input_name === 'internal_slab_colour') {
                setSelectedInternalSlabColourType(type);
            } else {
                setSelectedInternalColourType(type);
            }
        } else {
            // Use slab-specific setter when input_name is 'panel'
            if (input_name === 'panel') {
                setSelectedExternalSlabColourType(type);
            } else {
                setSelectedExternallColourType(type);
            }
            if (input_name === 'internal_slab_colour') {
                setSelectedInternalSlabColourType(type);
            } else {
                setSelectedInternalColourType(type);
            }
        }
    }, [selectedOption]);

    useEffect(() => {
        type === "standard"
            ? setColourArray(standardColors)
            : type === "oxide"
                ? setColourArray(oxideColors)
                : setColourArray(nonStandardColors);
    }, [type]);

    return (
        <Controller
        name={`${input_name ? input_name : `${view}_door_colour`}`}
        control={control}
        render={({ field }) => (
            <>
                {colourArray.map(({ code, bg, img }) => (
                    <div key={code} className="group">
                        <div
                            className={`relative flex flex-col items-center gap-4 w-fit p-4 transition-colors ${
                                field.value === code ? 'bg-[#555454]' : 'hover:bg-gray-100'
                            }`}
                        >
                            {type === "oxide" ? (
                                <img
                                    className="size-[5rem] object-contain"
                                    src={`${basePath}/${selectedDoor}/${type}/${view}/${code}-preview.png`}
                                    alt={code}
                                />
                            ) : (
                                <div
                                    className={`size-12 `}
                                    style={{ background: bg }}
                                />
                            )}
                            <p className={`text-xs uppercase ${
                                field.value === code ? 'text-white' : 'text-gray-600'
                            }`}>
                                {code.replace("_", " ")}
                            </p>
                            <input
                                className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer"
                                type="radio"
                                id={`${view}_${code}`}
                                name={`${input_name ? input_name : `${view}_door_colour`}`}
                                value={code}
                                checked={field.value === code}
                                onChange={(e) => {
                                    field.onChange(e);

                                    if(view === 'external' && currentView !== 'external'){
                                        setView('external');
                                    }

                                    // Handle external colour type setting

                                    // Handle external colour type setting
                                    if(view === 'external') {
                                        if (input_name === 'panel') {
                                            // For slab/panel colour, set the slab colour type
                                            setValue(`external_slab_colour_type`, type);
                                        } else {
                                            // For frame colour, set the frame colour type
                                            setValue(`external_door_colour_type`, type);
                                            // Only set oxide_frame_colour for oxide type
                                            if (type === 'oxide') {
                                                setValue('oxide_frame_colour', e.target.value);
                                            }
                                        }
                                    } else if (view === 'internal') {
                                        if (input_name === 'internal_slab_colour') {
                                            setValue(`internal_slab_colour_type`, type);
                                        } else {
                                            setValue(`internal_door_colour_type`, type);
                                        }
                                        if (input_name === 'panel') {
                                            // For slab/panel colour, set the slab colour type
                                            setValue(`external_slab_colour_type`, type);
                                        } else {
                                            // For frame colour, set the frame colour type
                                            setValue(`external_door_colour_type`, type);
                                            // Only set oxide_frame_colour for oxide type
                                            if (type === 'oxide') {
                                                setValue('oxide_frame_colour', e.target.value);
                                            }
                                        }
                                    } else if (view === 'internal') {
                                        if (input_name === 'internal_slab_colour') {
                                            setValue(`internal_slab_colour_type`, type);
                                        } else {
                                            setValue(`internal_door_colour_type`, type);
                                        }
                                    }
                                }}
                            />
                        </div>
                    </div>
                ))}
                   {(view === 'external' && oxide && selectedDoor === 'sumatra' && type !== 'oxide') &&  <p className="text-primary mb-0 underline w-full block py-4">Oxide Range</p> }
                {(view === 'external' && oxide && selectedDoor === 'sumatra' && type !== 'oxide') && (
                    oxideColors.map(({ code, bg }) => (
                        <div key={code} className="group">
                            <div
                                className={`relative flex flex-col items-center gap-4 w-fit p-4 transition-colors ${
                                    field.value === code ? 'bg-[#555454]' : 'hover:bg-gray-100'
                                }`}
                            >
                                <img
                                        className="size-[5rem] object-contain"
                                        src={`${basePath}/${selectedDoor}/oxide/${view}/${code}-preview.png`}
                                        alt={code}
                                    />
                                <p className={`text-xs uppercase ${
                                    field.value === code ? 'text-white' : 'text-gray-600'
                                }`}>
                                    {code.replace("_", " ")}
                                </p>
                                <input
                                    className="absolute inset-0 h-full w-full opacity-0 z-20 cursor-pointer"
                                    type="radio"
                                    id={`${view}_${code}`}
                                    value={code}
                                    checked={field.value === code}
                                    onChange={(e) => {
                                        field.onChange(e);
                                        if (view === 'external') {
                                            if (input_name === 'panel') {
                                                setValue(`external_slab_colour_type`, 'oxide');
                                            } else {
                                                setValue(`external_door_colour_type`, 'oxide');
                                            }
                                        } else {
                                            if (input_name === 'internal_slab_colour') {
                                                setValue(`internal_slab_colour_type`, 'oxide');
                                            } else {
                                                setValue(`internal_door_colour_type`, 'oxide');
                                            }
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    ))
                )}
            </>
        )}
    />
    );
};
export default DoorColourRadiogroup;

